<template>
  <div class="mail__mail-item px-4 md:px-2 py-2 my-1" :class="{'bg-warning-200': false,
                                                                'bg-gray-200': true}">
    <!-- CASE ROW 1 : META -->
    <div class="w-full flex">
      <div class="w-full flex flex-wrap justify-between items-start">
        <div class="w-full md:w-1/3 lg:w-1/6 flex flex-col pb-1 md:pb-0">
          <div class="flex flex-row space-x-1">
          <span class="font-bold">
            #{{ currentCase.id }}
          </span>
            <span>
            <i class="mr-2 flag-icon" :class="currencyFlagIcon"/>
          </span>
          </div>
          <div class="flex items-center">
            <span class="truncate"> {{ $t('pages.cases.casePreview.status') }}: {{ $t(`lists.caseStatus.${currentCase.caseStatus}`) }}</span>
          </div>
        </div>

        <!-- Owner and patient -->
        <div class="w-full md:w-1/3 lg:w-1/4 flex flex-col pb-1 md:pb-0">
          <!-- Owner -->
          <div class="w-full flex">
            <span class="truncate">{{ $t('pages.cases.caseView.requester') }}: {{ ownerName }}</span>
          </div>

          <!-- Patient -->
          <div class="w-full flex flex-row">
            <span>{{ $t('pages.cases.casePreview.patient') }}: </span>
            <span class="truncate" v-if="currentCase.patient"> {{ currentCase.patient.getDisplayName() }}</span>
          </div>
        </div>

        <!-- Created and dealine -->
        <div class="w-full md:w-1/3 lg:w-1/5 flex flex-col pb-1 md:pb-0">
          <div class="w-full flex">
            <span class="truncate"> {{ $t('pages.cases.casePreview.createdAt') }}: {{ currentCase.createdAt | to_date }}</span>
          </div>

          <div class="flex flex-row">
            <div class="w-full flex">
              <span> {{ $t('pages.cases.casePreview.deadlineAt') }}: </span>
              <template v-if="!currentCase.deadlineAt">
                <vx-tooltip :text="$t('pages.cases.casePreview.deadlineWarning')" position="top" delay=".3s">
                  <feather-icon icon="ClockIcon" class="cursor-pointer mx-1"
                                svg-classes="h-4 w-4 cursor-pointer rounded text-warning" />
                </vx-tooltip>
              </template>
              <template v-else>
              <span class="truncate">
                {{ currentCase.deadlineAt | to_date }}
              </span>
              </template>
            </div>
          </div>
        </div>

        <!-- Archive, mark solved, only for admin and supervisor -->
        <div class="w-1/4 lg:w-auto flex flex-wrap pb-1 md:pb-0" v-if="$store.state.Profile.isSupervisor()">
          <!-- Archive or next Case Step, only admin should be allowed to next step -->
          <vx-tooltip :text="$t('pages.cases.caseView.buttons.archiveCase')" position="top" delay=".3s" class="flex">
            <feather-icon icon="ArchiveIcon" class="cursor-pointer mx-1"
                          svg-classes="h-7 w-7 cursor-pointer p-1 rounded bg-gray-200 text-dark hover:bg-danger hover:text-white"
                          @click.stop="archiveCase"/>
          </vx-tooltip>
        </div>

        <!-- Right buttons, and open case -->
        <div class="w-full lg:w-1/4 flex flex-row lg:flex-col justify-end md:justify-start lg:justify-center">
          <div class="w-1/2 lg:w-full flex flex-row justify-end items-center pb-1">
            <!-- Payment information -->
            <bds-tooltip>
              <template #default>
                <feather-icon icon="DollarSignIcon" class="cursor-pointer mx-1"
                              :svg-classes="{'h-7 w-7 cursor-pointer p-1 rounded text-white': true,
                                        'bg-success': isPaied && !isPrePaied,
                                        'bg-warning': isPrePaied,
                                         'bg-danger': !isPaied && !isPrePaied }"/>
              </template>
            </bds-tooltip>

            <!-- Patient information -->
            <bds-tooltip>
              <template #default>
                <feather-icon icon="UserCheckIcon" class="cursor-pointer mx-1"
                              :svg-classes="{'h-7 w-7 cursor-pointer p-1 rounded text-white': true,
                                        'bg-success': isPatientDataOK,
                                        'bg-danger': !isPatientDataOK }"/>
              </template>
              <template #tooltipBody>
                <div class="flex flex-col" v-if="currentCase.patient.isValid()">
                  <span>{{ $t('pages.cases.caseView.tooltipPatientData') }}</span>
                  <bds-patient-card :patient-data="currentCase.patient" class="border border-primary"/>
                </div>
                <span v-else> {{ $t('pages.cases.casePreview.patientFulFill') }} </span>
              </template>
            </bds-tooltip>

            <!-- Service information TODO finalizar-->
            <bds-tooltip>
              <template #default>
                <feather-icon icon="AlertTriangleIcon" class="cursor-pointer mx-1"
                              :svg-classes="{'h-7 w-7 cursor-pointer p-1 rounded text-white': true,
                                        'bg-success': isServiceDataOK,
                                         'bg-danger': !isServiceDataOK }"/>
              </template>

              <template #tooltipBody>
                <div class="flex flex-col">
                  <span>{{ $t('pages.cases.caseView.tooltipServiceData') }}</span>
                  <div v-if="false"> <!-- TODO finalizar -->
                    <li v-for="case_service in currentCase.services" :key="case_service.id">
                      <ul>{{ case_service.valid() }}</ul>
                    </li>
                  </div>
                </div>
              </template>
            </bds-tooltip>

            <!-- Attachment information -->
            <bds-tooltip>
              <template #default>
                <feather-icon icon="PaperclipIcon" class="cursor-pointer mx-1"
                              :svg-classes="{'h-7 w-7 cursor-pointer p-1 rounded text-white': true,
                                        'bg-success': isAttachmentOK,
                                         'bg-danger': !isAttachmentOK }"/>
              </template>

              <template #tooltipBody>
                <div class="flex flex-col">
                  <span> {{ $t('pages.cases.caseView.tooltipAttachment') }} </span>
                </div>
              </template>
            </bds-tooltip>

            <!-- Observation information -->
            <bds-tooltip>
              <template #default>
                <feather-icon icon="Edit3Icon" class="cursor-pointer mx-1"
                              :svg-classes="{'h-7 w-7 cursor-pointer p-1 rounded text-white': true,
                                        'bg-success': isObservationOK,
                                         'bg-warning': !isObservationOK }"/>
              </template>

              <template #tooltipBody>
                <div class="flex flex-col">
                  <span> {{ $t('pages.cases.caseView.tooltipObservation') }} </span>
                  <div class="border border-primary" v-if="currentCase.observation">
                    <span> {{ currentCase.observation | readMore(100) }} </span>
                  </div>
                </div>
              </template>
            </bds-tooltip>

            <div class="flex justify-start" @click="toggleNotification">
              <feather-icon icon="BellIcon" class="cursor-pointer mx-2" svg-classes="h-7 w-7 cursor-pointer p-1 rounded text-white bg-success"
                            :badge="getUnreadNotifications" v-if="getTriggerNotification"/>
              <feather-icon icon="BellOffIcon" class="cursor-pointer mx-2" svg-classes="h-7 w-7 cursor-pointer p-1 rounded text-white bg-danger"
                            v-else />
            </div>
          </div>

          <div class="w-1/2 lg:w-full flex justify-end">
            <vs-button size="small" color="primary" icon-pack="feather" icon="icon-log-in" @click="openCase">
              {{ $t('pages.cases.casePreview.openCase') }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>

    <template v-if="currentCase.isReview() && filterReview">
      <vs-divider class="my-1"/>
      <div class="w-full flex flex-wrap">
        <div class="w-full md:w-1/3 px-1" v-for="case_review in currentCase.reviews" :key="case_review.id">
          <div>
            <span class="text-sm text-warning uppercase">
              {{ $t('pages.cases.casePreview.reviewTitle') }}
            </span>
          </div>

          <div class="w-full flex border border-warning rounded-lg px-2">
            <div class="w-2/3">
              <span>
                {{ $t(`lists.review_description.${case_review.description}`) }}
              </span>
            </div>

            <div class="w-1/3 flex justify-end">
              <vx-tooltip :text="$t('pages.cases.markAsSolved')" position="top" delay=".3s" class="flex">
                <feather-icon icon="PlayCircleIcon" class="cursor-pointer mx-1"
                              svg-classes="h-7 w-7 cursor-pointer p-1 rounded bg-gray-200 text-dark hover:bg-primary hover:text-white"
                              @click.stop="markAsSolved(case_review.id)"/>
              </vx-tooltip>
            </div>
          </div>
        </div>
      </div>
    </template>

    <vs-divider class="my-2"/>

    <!-- Services -->
    <div class="w-full flex flex-wrap">
      <case-product-list-item v-for="case_service in currentCase.services" :case-service="case_service"
                              :key="case_service.id"
                              class="w-1/2 md:w-1/3 lg:1/4 px-1">

        <template #plannerName v-if="$store.state.Profile.isSupervisor()">
          <choose-planner :user-id="case_service.plannerId" :parent-id="case_service.id"
                          inner-insert @change="changePlanner"
                          class="w-full" v-if="currentCase.isReview() && filterReview"/>
        </template>
      </case-product-list-item>
    </div>
  </div>
</template>

<script>
import {getLangByValue} from '@/helpers/lists';
import {showErrorNotify, showSuccessNotify} from "@/helpers/functionsHelpers";
import CaseProductListItem from "@/views/cases/Components/CaseProductListItem";
import ChoosePlanner from "@/views/cases/Components/ChoosePlanner";
import CaseService from "@/services/Case.service";

export default {
  name: 'case-preview',
  components: {
    ChoosePlanner,
    CaseProductListItem,
  },
  props: {
    currentCase: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      ownerName: '',
    }
  },
  watch: {
    'currentCase.owner_id'() {
      this.getOwnerUser();
    }
  },
  computed: {
    filterReview() {
      return this.$route.params.filter === 'revision';
    },
    isPrePaied() {
      return this.currentCase.isTherePrePaidTransactions();
    },
    isPaied() {
      return this.currentCase.validateTransactions();
    },
    isPatientDataOK() {
      return this.currentCase.validatePatient();
    },
    isServiceDataOK() {
      return this.currentCase.isServicesDataValid();
    },
    isAttachmentOK() {
      return this.currentCase.isAttachmentsValid();
    },
    isObservationOK() {
      return this.currentCase.observation;
    },
    currencyFlagIcon() {
      return getLangByValue(this.currentCase.caseCurrency).icon
    },
    getTriggerNotification() {
      return this.$store.getters['Notifications/getCaseNotificationTrigger'](this.currentCase.id);
    },
    getUnreadNotifications() {
      return this.$store.getters['Notifications/getCaseUnseenNotification'](this.currentCase.id);
    }
  },
  methods: {
    markAsSolved(reviewId) {
      this.$alma.dialogConfirm({
        title: this.$t('pages.cases.casePreview.reviewConfirmMessageTitle'),
        textBody: this.$t('pages.cases.casePreview.reviewConfirmMessageBody'),
      }).then((confirm) => {
        if (confirm) {
          this.$emit('markReviewSolved', reviewId);
        }
      });
    },
    archiveCase() {
      this.$emit('archiveCase', this.currentCase.id);
    },
    changePlanner(service) {
      const payload = {
        planner_id: service.userId
      };

      CaseService.changeServicePlanner(service.id, payload).then((response) => {
        this.$store.dispatch('Case/setCase', response).then(() => {
          showSuccessNotify(this, this.$t('components.choosePlanner.successMessage'));
        });
        this.edit = false;
      }, error => {
        showErrorNotify(this, error);
      });
    },
    openCase() {
      this.$nextTick(() => {
        this.$router.push(`/cases/${this.currentCase.id}`);
      });
    },
    toggleNotification() {
      CaseService.toggleNotification(this.currentCase.id).then((response) => {
        this.$store.dispatch('Notifications/setStatusCaseNotification', response);
      }, (error) => {
        showErrorNotify(this, error);
      })
    },
    getOwnerUser() {
      this.$store.dispatch('Users/lookupUser', this.currentCase.owner_id).then((response) => {
        this.ownerName = response.getDisplayName();
      }, error => {
        showErrorNotify(this, error);
      });
    }
  },
  mounted() {
    this.getOwnerUser();
  }
}

</script>

